module.exports = __webpack_public_path__ + "static/media/formations.dfc9aa9b.png";